// Route wrappers binding the shared sample screens into both shells:
// admin = customer (sees all, can edit), supply = factory (own org, non-draft).

import { SampleRequestsList } from './SampleRequestsList'
import { SampleRequestDetail } from './SampleRequestDetail'
import { SampleBulkAdoptPage } from './SampleBulkAdoptPage'

export function AdminSamplesList() {
  return <SampleRequestsList mode="all" isFactory={false} basePath="/admin/samples" />
}
export function AdminSamplesTrash() {
  return <SampleRequestsList mode="trash" isFactory={false} basePath="/admin/samples" />
}
export function SupplySamplesList() {
  return <SampleRequestsList mode="all" isFactory basePath="/supply/samples" />
}
// Admin-only worksheet: the whole received shelf into the catalog at once.
export function AdminSamplesBulkAdopt() {
  return <SampleBulkAdoptPage />
}
export function AdminSampleDetail() {
  return <SampleRequestDetail isFactory={false} basePath="/admin/samples" />
}
export function SupplySampleDetail() {
  return <SampleRequestDetail isFactory basePath="/supply/samples" />
}
